import * as React from "react";
const ESSVG = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 115.73 260.08"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        isolation: isolate;\n        opacity: .68;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #f26522;\n        stroke: #c0272d;\n        stroke-miterlimit: 2.6;\n        stroke-width: .39px;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g id="g6878">
        <g id="g3442">
          <g id="g3484">
            <path
              id="path3486"
              className="cls-1"
              d="M51.29,98.81s4.61,42.76,6.64,50.13c0,0,1.29,37.6,11.24,39.81,0,0,4.79-16.41,17.88-16.41,0,0,30.41-8.11,28.38,27.83,0,0-11.24,20.64-27.28,27.28,0,0-7.74,11.06-16.87,16.87-6.81,4.33-15.21,6.46-23.25,5.34-2.73-.38-5.42-1.13-7.99-2.3-2.79-1.27-5.86-4.73-8.09-6.81-1.99-1.86-3.35-4.23-5.47-6.02-3.83-3.24-10.03-5.85-13.3-.45-1.65,2.72-1.37,7.32-.67,10.27.63,2.65,2.06,4.4,3.64,6.48,1.21,1.59,2.06,2.55,1.2,4.54-.97,2.23-3.22,3.74-5.56,4.34-2.44.63-3.89-.65-5.48-2.37-4.72-5.12-6.17-13.53-5.62-20.25.61-7.49,5.11-13.62,11.49-17.42,5.23-3.12,12.65-5.45,18.42-2.28,2.39,1.31,4.63,3.13,6.87,4.71,1.75,1.24,3.99,3.14,6.27,3.14,4.98,0,9.58-4.61,9.58-6.45,0,0,7.19-18.8,7.19-22.49,0,0-10.51-14.19-12.53-34.65-5.2-78.77-1.75-67.18,3.32-62.85Z"
            />
            <path
              id="path3488"
              className="cls-2"
              d="M47.65,249.28c-2.73-.38-5.42-1.13-7.99-2.3-2.79-1.27-5.86-4.73-8.09-6.81-1.99-1.86-3.35-4.23-5.47-6.02-3.83-3.24-10.03-5.85-13.3-.45-1.65,2.72-1.37,7.32-.67,10.27.63,2.65,2.06,4.4,3.64,6.48,1.21,1.59,2.06,2.55,1.2,4.54-.97,2.23-3.22,3.74-5.56,4.34-2.44.63-3.89-.65-5.48-2.38-4.72-5.12-6.17-13.53-5.62-20.25.61-7.49,5.11-13.62,11.49-17.42,5.23-3.12,12.65-5.45,18.42-2.28,2.39,1.31,4.63,3.13,6.87,4.71,1.75,1.24,3.99,3.14,6.27,3.14,4.98,0,9.58-4.61,9.58-6.45,0,0,7.19-18.8,7.19-22.49,0,0-10.51-14.19-12.53-34.65,0,0-1.29-26.17-4.05-36.86,0,0-6.49-108.34-6.49-124.19,12.95,1.28,8.54-.45,13.86,98.2,0,0,4.61,42.76,6.63,50.13,0,0,1.29,37.6,11.24,39.81,0,0,4.79-16.4,17.88-16.4,0,0,30.41-8.11,28.38,27.83,0,0-11.24,20.64-27.28,27.28,0,0-7.74,11.06-16.87,16.87-6.81,4.33-15.21,6.46-23.25,5.34ZM40.87,227.53c-5.54-1.49-8.88-8.4-14.55-9.85-11.19-2.87-23.52,9.05-24.23,19.74-.23,3.49-.98,11.48,3.18,13.21,2.15.89,5.83-.89,6.23-3.17.34-1.95-1.39-4.97-1.55-7.06-.35-4.6.9-8.62,5.07-10.95,7.49-4.19,14.34,5.72,18.78,10.14,2.75,2.74,5.99,5.16,9.63,6.42,9.53,3.3,24.89-1.44,31.9-8.69,4.15-4.3,7.12-8.41,11.91-12.13,9.68-7.51,25.09-17.67,25.18-31.4.08-11.62-9.75-20.36-21.55-19.18-7.6.76-15.22,4.38-19.06,11.3-.72,1.31-2.58,5.76-3.82,5.87-3.39.32-4.76-5.69-6.22-7.81-1.53-2.22-3.37-2.59-4.29.38-.67,2.19.41,5.1,1.55,6.95.81,1.31,2.25,2.62,2.68,4.13.62,2.16.01,5.9-.89,7.94-3.93,8.94-4.65,24.03-17.57,24.43-.85.03-1.65-.08-2.4-.28Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default ESSVG;
